export default __webpack_public_path__ + "static/media/non-ready.8521ee9d.svg";